import React from 'react';

const ErrorPage = () => (
  <div className="row u-navbar-padding">
    <div className="column">
      <h1>Oops! Something went wrong.</h1>
      <p>We have encountered an error, but rest assured, We are on it!</p>
      <p>Our team is already hard at work to fix the issue and ensure everything runs smoothly again.</p>
      <p>Thank you for your patience and understanding.</p>
    </div>
  </div>
);

export default ErrorPage;
